export default {
  // Chưa gửi duyệt
  FileNotSentToChiefAccountant: 4,
  // Chưa gửi thủ trưởng duyệt
  FileNotSent: 1,
  // Chờ kế toán trưởng duyệt: 0
  Waiting: 0,
  // Kế toán trưởng từ chối duyệt
  CompanyChiefAccountantReject: -1,
  // Chờ thủ trưởng duyệt
  WaitingCompanyDirector: 2,
  // Thủ trưởng đã duyệt
  CompanyDirectorApproved: 3,
  // Thủ trưởng từ chối duyệt
  CompanyDirectorReject: -2,
};
